{
  "DatePattern": "DD-MMM-YYYY",
  "NAME": "Date"
}